var map = {
	"./app/1.png": 43,
	"./app/2.png": 88,
	"./app/3.png": 89,
	"./app/4.png": 90,
	"./app/5.png": 91,
	"./app/6.png": 41,
	"./app/7.png": 92,
	"./app/8.png": 93,
	"./app/9.png": 94,
	"./app/pieces/1.png": 45,
	"./app/pieces/2.png": 46,
	"./app/pieces/3.png": 47,
	"./app/pieces/4.png": 31,
	"./app/pieces/5.png": 32,
	"./designer.png": 95,
	"./tablet/1.png": 42,
	"./tablet/2.png": 96,
	"./tablet/3.png": 97,
	"./wmockup/1.png": 98
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;